<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-04 15:40:04
 -->
<template>
  <div @click="jump()" class="vux-1px-b">
    <p class="p1">
      <span class="s1">专区</span>
      <span>{{ channelObj.title }}</span>
    </p>
    <p class="p2">
      <span>{{ channelObj.videoNum }}课程</span>
      <span>·</span>
      <span>{{ channelObj.subNum }}订阅</span>
    </p>
    <i class="icon iconfont icon-enter"></i>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    channelObj: {
      type: Object,
      default: function() {
        return {
          //            bgUrl: null
          //            externalLink: ""
          //            id: "3a03446a-8256-4999-92a4-4087718b301b"
          //            isExternalLink: 0
          //            newestUpdate: null
          //            relationCourseNum: 27
          //            showTimeFormat: null
          //            subNum: 1138
          //            title: "呼吸疑难病例全解析"
          //            updateTime: null
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    jump() {
      let { id, isExternalLink, externalLink } = this.channelObj;
      if (isExternalLink == 1 && externalLink) {
        location.href = externalLink;
      }
      this.$router.push({ name: 'universally', params: { id } });
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
@import '../../public/style/g.less';

div {
  margin-top: 0.4rem;
  position: relative;
  .borderPadding();
  * {
    font-size: 0.32rem;
  }
  .p1 {
    display: flex;
    align-items: center;
    span:nth-of-type(1) {
      width: 1.12rem;
      height: 0.533rem;
      .textAlignLineHight(0.533rem);
      background-image: linear-gradient(-90deg, #f76b1c 0%, #fad961 100%);
      border-radius: 0.08rem;
      color: #fff;
      margin-right: 0.266rem;
    }
    span:nth-of-type(2) {
      font-size: 0.4266rem;
      font-weight: bold;
    }
  }
  .p2 {
    margin-top: 0.1866rem;
    font-weight: bold;
    span:nth-of-type(2) {
      margin: 0 0.1866rem;
    }
  }
  i {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 0.4rem;
  }
}
</style>
